import { DialogId } from '@feedyou/schema'
import { DialogHierarchyMap } from '../../dialogRelation'
import { FoundOccurrence } from './searchInDialogs'

export function getDialogsNestingFoundOccurrences(
  occurrences: FoundOccurrence<'full'>[],
  dialogsConnectionMap: DialogHierarchyMap
) {
  const dialogIds = new Set<DialogId>()

  for (const occurrence of occurrences) {
    dialogIds.add(occurrence.foundOnEntity.dialog)

    const ancestors =
      dialogsConnectionMap.get(occurrence.foundOnEntity.dialog)?.ancestors || new Set()

    for (const ancestorId of ancestors) {
      dialogIds.add(ancestorId)
    }
  }

  return dialogIds
}
